module.exports = __webpack_public_path__ + "static/media/benefits-img-4.4dfa7cf7.png";